module.exports = __webpack_public_path__ + "media/assets/icon_calendar_blue_outline-53eb7462361bb54a4264101eeb87fbb0a474d89f12fde69b939d296bf1e38c9e.svg";